import _ from 'lodash';
import { getSelectedPolicy } from './changeContactSelector';
import { getContactDetailsPolicy } from './contactDetailsSelector';
import { LocalizedText } from 'src/types/LocalizedTextTypes';
import { AddressInLines } from '../types/changeAddressTypes';
import { MapAddressInputType } from '../reducers/changeAddressReducer';

export const getHKAddressInput = (state: unknown) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.changeAddress.hkAddressInput`,
    {},
  );
};

export const getGoGreenList = (state: unknown) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.changeAddress.goGreenList`,
    [],
  );
};

export const getOtherPolicyList = (state: unknown) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.changeAddress.otherPolicyList`,
    [],
  );
};

export const getSelectedList = (state: unknown) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.changeAddress.selectedList`,
    [],
  );
};

export const getChangeAddressStepContext = (state: unknown) => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-customer-profile.changeAddressStepContext`,
    {},
  );
};

export const getChangeAddressLabels = (state: unknown) => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-customer-profile.changeAddressLabels`,
    {},
  );
};

export const getChangeAddressNote = (
  state: any,
): {
  title: LocalizedText;
  contentShort: LocalizedText;
  contentFull: LocalizedText;
  policyServicingForm: LocalizedText;
  policyServicingFormUrl: LocalizedText;
} => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-customer-profile.changeAddressNote`,
    {},
  );
};

export const getAddressOutOfHKSystemMessage = (
  state: unknown,
): {
  title: LocalizedText;
  description: LocalizedText;
} => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-customer-profile.addressOutOfHKSystemMessage`,
    {},
  );
};

export const getAddressOutOfHKDialog = (
  state: unknown,
): {
  title: LocalizedText;
  description: LocalizedText;
  downloadCta: LocalizedText;
  closeCta: LocalizedText;
} => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-customer-profile.addressOutOfHKDialog`,
    {},
  );
};

export const getPolicyServiceFormUrl = (state: unknown): LocalizedText => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-customer-profile.policyServiceFormUrl`,
    {},
  );
};

export const getStreetBuildingEstateMessage = (
  state: any,
): {
  title: LocalizedText;
  content: LocalizedText;
} => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-customer-profile.changeAddressLabels.streetBuildingEstateMessage`,
    {},
  );
};

export const getAddressAbbreviationLabel = (
  state: any,
): {
  title: LocalizedText;
  type: LocalizedText;
  abbreviation: LocalizedText;
  gotIt: LocalizedText;
} => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-customer-profile.addressAbbreviationLabel`,
    {},
  );
};

export const getNewAddress = (state: unknown): AddressInLines => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.changeAddress.address`,
    {},
  );
};

export const getIsLoading = (state: unknown) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.changeAddress.isLoading`,
    false,
  );
};

export const getForm = (state: unknown) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.changeAddress.form`,
    {},
  );
};

export const getTransactionId = (state: unknown) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.changeAddress.transactionId`,
    '',
  );
};

export const getAddressModel = (state: unknown) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.changeAddress.address`,
    {},
  );
};

export const getAddressText = (state: unknown) => {
  const selectedPolicy = getSelectedPolicy(state);
  const { policyNumber } = selectedPolicy;
  const policyDetails = getContactDetailsPolicy(state, policyNumber);
  const { addressText = '' } = policyDetails;
  return addressText;
};

export const getIsShowAddressPopup = (state: unknown) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.changeAddress.isShowAddressPopup`,
    false,
  );
};

export const getIsConfirmLoadingButton = (state: unknown) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.changeAddress.isConfirmLoadingButton`,
    false,
  );
};

export const getIsHappyHKCase = (state: unknown) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.changeAddress.isHappyHKCase`,
    false,
  );
};

export const getIsGoogleMapJsScriptComplete = (state: unknown) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.changeAddress.isGoogleMapJsScriptComplete`,
    false,
  );
};

export const getIsLoadingEditPage = (state: unknown) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.changeAddress.isLoadingEditPage`,
    false,
  );
};

export const getIsGoogleMapJsScriptError = (state: unknown) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.changeAddress.isGoogleMapJsScriptError`,
    false,
  );
};

export const getAddressFromMapView = (state: unknown): MapAddressInputType => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.changeAddress.MapAddressInput`,
    {},
  );
};

export const getIsChosenNonHKAddress = (state: unknown): boolean => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.changeAddress.isChosenNonHKAddress`,
    {},
  );
};

export const getIsClearSearchValue = (state: unknown): boolean => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.changeAddress.isClearSearchValue`,
    false,
  );
};

export const getIsAutoFilled = (state: unknown): boolean => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.changeAddress.isAutoFilled`,
    false,
  );
};
